import * as configurations from '../configuration/servers';
import * as currentConfig from '../configuration/config.json';
import * as languages from '../configuration/languages';

let debug = false;

const THEMES = {
    LABMEDICA: 'lmi',
    HOSPIMEDICA: 'hmi'
};

const SITE_NAMES = {
    [THEMES.LABMEDICA]: 'Labmedica',
    [THEMES.HOSPIMEDICA]: 'Hospimedica'
};

function detectLanguagePrefix(host) {
    if (!host) return 'en';
    return host.includes('.es') || host.includes('.es.') || host.startsWith('es.') ? 'es' : 'en';
}

function detectTheme(host) {
    if (!host) return THEMES.LABMEDICA;
    return host.includes('hospimedica') ? THEMES.HOSPIMEDICA : THEMES.LABMEDICA;
}

function detectEnvironment(host) {
    if (!host) return 'prod';
    if (host.includes('axis')) return 'axis';
    if (host.includes('onserv')) return 'onserv';
    if (host.includes('track21')) return 'track';
    return 'prod';
}

function detectServerKey(host, theme, language) {
    const environment = detectEnvironment(host);
    const brand = theme === THEMES.HOSPIMEDICA ? 'Hospimedica' : 'Labmedica';

    if (environment === 'track') {
        return `track${brand}`;
    }

    const languagePart = language === 'es' ? 'Es' : '';
    return `${environment}${languagePart}${brand}`;
}

const host = (window.location.hostname || '').toLowerCase();
const protocol = window.location.protocol;
const isMobileVersion = host.startsWith('mobile.');

let siteTheme = detectTheme(host);
let fullSiteName = SITE_NAMES[siteTheme];
let languagePrefix = detectLanguagePrefix(host);

const resolvedServerKey = detectServerKey(host, siteTheme, languagePrefix);
let currentServer = configurations[resolvedServerKey] || configurations[currentConfig.currentServer];
let siteUrl = (currentServer && currentServer.serverApi)
    ? currentServer.serverApi
    : `${protocol}//${window.location.hostname}/`;

if (isMobileVersion && currentServer && currentServer.mobileDomain) {
    siteUrl = `${protocol}//${currentServer.mobileDomain}/`;
}

localStorage.setItem('lang', languagePrefix);

if (debug) {
    console.log('[ConfigurationService]: resolvedServerKey', resolvedServerKey);
    console.log('[ConfigurationService]: siteTheme', siteTheme);
    console.log('[ConfigurationService]: siteUrl', siteUrl);
    console.log('[ConfigurationService]: languagePrefix', languagePrefix);
}


export default class ConfigurationService {

    defineTheme(){
        const currentHost = (window.location.hostname || '').toLowerCase();
        siteTheme = detectTheme(currentHost);
        fullSiteName = SITE_NAMES[siteTheme];
        return siteTheme;
    }   

    getSiteTheme(){
        return siteTheme;
    }

    getFullSiteName(){
        return fullSiteName;
    }

    getCurrentServer() {
        if (debug) {
            console.log('[ConfigurationService]: currentServer', currentServer);
        }
        return currentServer;
    }

    getCurrentSite() {
        return siteUrl;
    }

    getCurrentLanguage() {
        const currentLanguagePrefix = localStorage.getItem('lang') || languagePrefix;
        return languages[currentLanguagePrefix] || languages.en;
    }

    switchLanguage(lang) {
        switch (lang) {
            case 'en': {
                localStorage.setItem('lang', 'en');
                languagePrefix = 'en';
                break;
            }
            case 'es': {
                localStorage.setItem('lang', 'es');
                languagePrefix = 'es';
                break;
            }
            default: {
                localStorage.setItem('lang', 'en');
                languagePrefix = 'en';
                break;
            }
        }
    }

    getCurrentLanguagePrefix() {
        return languagePrefix;
    }

    insertLinksToHead(prev, next) {
        try {

            // if (document.getElementById("canonical") != null) {
            //     document.getElementById("canonical").remove();
            // }
            if (document.getElementById("alternate") != null) {
                document.getElementById("alternate").remove();
            }
            if (document.getElementById("alternate") == null 
            
                // || document.getElementById("canonical") == null
                ) {
                // const seoLinksCan = document.createElement('link');
                // seoLinksCan.setAttribute('rel', 'canonical');
                // seoLinksCan.setAttribute('id', 'canonical');
                // seoLinksCan.setAttribute('href', document.URL);
                // document.head.appendChild(seoLinksCan);

                const seoLinksAlt = document.createElement('link');
                seoLinksAlt.setAttribute('rel', 'alternate ');
                seoLinksAlt.setAttribute('id', 'alternate');
                seoLinksAlt.setAttribute('href', document.URL.replace('//www.', '//mobile.'));
                document.head.appendChild(seoLinksAlt);

            }
            if (document.getElementById("prev") != null) {
                document.getElementById("prev").remove();
            }
            if (document.getElementById("next") != null) {
                document.getElementById("next").remove();
            }
            if (prev) {
                const seoLinksPrev = document.createElement('link');
                seoLinksPrev.setAttribute('rel', 'prev');
                seoLinksPrev.setAttribute('id', 'prev');
                seoLinksPrev.setAttribute('href', prev);
                document.head.appendChild(seoLinksPrev);
            }
            if (next) {
                const seoLinksNext = document.createElement('link');
                seoLinksNext.setAttribute('rel', 'next')
                seoLinksNext.setAttribute('id', 'next');
                seoLinksNext.setAttribute('href', next);
                document.head.appendChild(seoLinksNext);
            }
            if (document.getElementById('productApplactionLd') !== null && !document.URL.includes('/product/')) {
                document.getElementById('productApplactionLd').remove();
            }
        } catch (error) {
            console.error('[ConfigurationService]: insertLinksToHead error', error)
        }
    }
}

